import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner } from './UI';

export function ProtectedRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: 'var(--paper)' }}>
        <Spinner size={32} />
      </div>
    );
  }

  return user ? <Outlet /> : <Navigate to="/signup" replace />;
}